import { createUseStyles } from 'react-jss'
import { colors } from '../../variables.style'

export const style = {
  leftSide: {
    composes: 'flex-row flex-center-items flex-auto',
    textAlign: 'center',
    padding: 40
  },
  rightSide: {
    padding: 40
  },
  leftSideContent: {
    composes: 'flex-column',
    alignItems: 'center'
  },
  reportType: {
    fontSize: 14,
    color: 'white',
    backgroundColor: colors.gunMetal,
    textTransform: 'uppercase',
    marginBottom: '6px',
    padding: '4px 14px 5px 14px'
  },
  reportTypeEdit: {
    marginBottom: 20,
    width: 240,
    textAlign: 'left'
  },
  title: {
    composes: 'h1',
    margin: 0
  },
  reportTitleEdit: {
    width: 400
  },
  titleTextField: {
    fontSize: 28,
    fontFamily: 'Raleway',
    fontVariantNumeric: 'lining-nums',
    height: 60
  },
  published: {
    marginTop: 10
  },
  summary: {
    composes: 'summary-justified',
    fontSize: 13,
    maxWidth: 400,
    marginTop: 50
  },
  reportDescriptionEdit: {
    width: 400,
    marginTop: 40
  },
  logo: {
    width: 140,
    position: 'absolute',
    bottom: 40
  },
  tocContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    marginBottom: 40
  },
  toc: {
    composes: 'flex-auto',
    fontSize: 26,
    textTransform: 'uppercase'
  },
  executiveSummaryLink: {
    marginTop: 10
  }
}

export const useStyles = createUseStyles(style)
